// Componente de tela de carregamento completa
"use client";

import { Box, Typography, CircularProgress } from "@mui/material";

interface LoadingScreenProps {
  title?: string;
  subtitle?: string;
  size?: number;
}

export default function LoadingScreen({
  title = "Processando...",
  subtitle = "Aguarde enquanto conectamos você ao sistema.",
  size = 60,
}: LoadingScreenProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        textAlign: "center",
        p: 4,
      }}
    >
      <CircularProgress
        size={size}
        sx={{
          mb: 3,
          color: "primary.main",
        }}
      />
      <Typography
        variant="h5"
        component="h2"
        sx={{
          mb: 2,
          fontWeight: 600,
          color: "text.primary",
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          maxWidth: 400,
          lineHeight: 1.6,
        }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
}
